<!--
 * @Author: Du Feng
 * @LastEditors: chenJunHui
 * @Date: 2021-12-02 10:27:30
 * @LastEditTime: 2022-05-17 09:50:43
 * @Description: Modify here please
-->
<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span> {{ info.q }} 学生报名详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="form" label-width="90px">
        <el-form-item label="">
          <el-select
            v-model="form.campusId"
            clearable
            placeholder="选择校区"
            class="label"
          >
            <el-option
              v-for="item in campusList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="form.gradeId"
            clearable
            placeholder="选择年级"
            class="label"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="form.studentName"
            clearable
            placeholder="请输入学生姓名"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="searchFun"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="studentName" label="学生姓名" align="center">
          </el-table-column>
          <el-table-column prop="className" label="班级" align="center">
          </el-table-column>
          <el-table-column prop="signTime" label="报名时间" align="center">
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="page.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index";
export default {
  props: {
    info: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      form: {
        campusId: "",
        gradeId: "",
        studentName: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      tableData: [
        // {studentName:'马岚信',className:'三年级2班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'乌爽霭',className:'二年级4班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'赵菲苑',className:'二年级6班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'穆玉蓉',className:'一年级4班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'宗环舒',className:'一年级5班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'葛怡秀',className:'三年级2班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'娄君娅',className:'一年级6班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'尚孝菁',className:'三年级7班',signTime:'2021/8/28 9:09:58'},
        // {studentName:'贝芬慧',className:'二年级4班',signTime:'2021/8/28 9:09:58'},
      ],
      campusList: [
        {id:'campus1',label:'驻马店实验小学主校区'},
      ],
      gradeList: [
        {id:'g1',label:'一年级'},
				{id:'g2',label:'二年级'},
				{id:'g3',label:'三年级'},
				{id:'g4',label:'四年级'},
				{id:'g5',label:'五年级'},
				{id:'g6',label:'六年级'},
      ],
      school_info: JSON.parse(sessionStorage.getItem("classList"))||[],
    };
  },
 watch: {
    info: {
      handler: function () {
        // this.getDataList();
      },
      deep: true,
    },
    // "form.campusId": function (n, o) {
    //   this.form.gradeId = "";
    //   this.gradeList = [];
    //   this.gradeList =
    //     this.campusList.filter((v) => v.id === n)[0]?.children || [];
    // },
  },
  created() {
    // this.getDataList();
    // if(this.school_info.length>0){
    //     this.campusList = this.school_info.slice();
    // }
  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: "",
        gradeId: this.form.gradeId,
        campusId: this.form.campusId,
        courseName: "",
        courseApplyId: this.info.courseApplyId,
        studentName: this.form.studentName,
        orgId:sessionStorage.getItem('orgId'),
        platformCode: sessionStorage.getItem('platformCode'),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      var { data, code } = await api.handleStudentDetails(params);
      console.log("获取列表数据---", data, code);
      if (code == "0") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
        //  this.page.pageSize=data.pageSize
        //  this.page.pageNum=data.pageNum
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("to-index");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
